import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Grid, Avatar, Typography, Stack, Button, Chip, TextField, LinearProgress, Card, CardContent, Box, Alert, Tabs, Tab, Paper, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import FaceIcon from '@mui/icons-material/Face';
import IconButton from '@mui/material/IconButton';
import WarningIcon from '@mui/icons-material/Warning';
import SendIcon from '@mui/icons-material/Send';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import PeopleIcon from '@mui/icons-material/People';
import HistoryIcon from '@mui/icons-material/History';
import SmsIcon from '@mui/icons-material/Sms';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { DataGrid } from '@mui/x-data-grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import api from '../utils/api';

const UserProfile = () => {
  const [avatarUrl, setAvatarUrl] = useState('');
  const [Name, setName] = useState('');
  const [Cell, setCell] = useState('');
  const [idUser, setId] = useState('');
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [token, setToken] = useState('');
  const [progress, setProgress] = useState(100);
  const [number, setNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [tabValue, setTabValue] = useState(0);
  const [usuariosInvitados, setUsuariosInvitados] = useState([]);
  const [registrosMarcas, setRegistrosMarcas] = useState([]);
  const [sesiones, setSesiones] = useState([]);
  const [loadingData, setLoadingData] = useState(false);



  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      cargarUsuariosInvitados();
    } else if (newValue === 2) {
      cargarRegistrosMarcas();
    } else if (newValue === 3) {
      cargarSesiones();
    }
  };

  const cargarUsuariosInvitados = async () => {
    setLoadingData(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/crearuser/all`);
      const data = await response.json();
      setUsuariosInvitados(data.users || []);
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      setErrorMessage('Error al cargar usuarios invitados');
    } finally {
      setLoadingData(false);
    }
  };

  const cargarRegistrosMarcas = async () => {
    setLoadingData(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/registros-marcas/all`);
      const data = await response.json();
      setRegistrosMarcas(data.registros || []);
    } catch (error) {
      console.error('Error al cargar registros:', error);
      setErrorMessage('Error al cargar registros de marcas');
    } finally {
      setLoadingData(false);
    }
  };

  const cargarSesiones = async () => {
    setLoadingData(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/sessions/all`);
      const data = await response.json();
      setSesiones(data.sessions || []);
    } catch (error) {
      console.error('Error al cargar sesiones:', error);
      setErrorMessage('Error al cargar sesiones activas');
    } finally {
      setLoadingData(false);
    }
  };

  const eliminarUsuario = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este usuario?')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/crearuser/${id}`, {
          method: 'DELETE'
        });
        setSuccessMessage('Usuario eliminado exitosamente');
        cargarUsuariosInvitados();
      } catch (error) {
        setErrorMessage('Error al eliminar usuario');
      }
    }
  };

  const eliminarRegistro = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/registros-marcas/${id}`, {
          method: 'DELETE'
        });
        setSuccessMessage('Registro eliminado exitosamente');
        cargarRegistrosMarcas();
      } catch (error) {
        setErrorMessage('Error al eliminar registro');
      }
    }
  };

  const resetearUsuario = async (telefono) => {
    if (window.confirm('¿Resetear el proceso de este usuario?')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/registros-marcas/reset/${telefono}`, {
          method: 'POST'
        });
        setSuccessMessage('Usuario reseteado exitosamente');
        cargarRegistrosMarcas();
      } catch (error) {
        setErrorMessage('Error al resetear usuario');
      }
    }
  };

  const enviarSMS = async (telefono) => {
    const mensaje = prompt('Escribe el mensaje a enviar:');
    if (mensaje) {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-sms`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            to: telefono,
            message: mensaje
          })
        });
        const data = await response.json();
        if (data.success) {
          setSuccessMessage('SMS enviado exitosamente');
        } else {
          setErrorMessage('Error al enviar SMS');
        }
      } catch (error) {
        setErrorMessage('Error al enviar SMS');
      }
    }
  };

  const limpiarTodosLosUsuarios = async () => {
    if (window.confirm('⚠️ ¿ELIMINAR TODOS LOS USUARIOS? Esta acción no se puede deshacer.')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/crearuser/clear/all`, {
          method: 'DELETE'
        });
        setSuccessMessage('Todos los usuarios eliminados');
        cargarUsuariosInvitados();
      } catch (error) {
        setErrorMessage('Error al limpiar usuarios');
      }
    }
  };

  const limpiarTodosLosRegistros = async () => {
    if (window.confirm('⚠️ ¿ELIMINAR TODOS LOS REGISTROS? Esta acción no se puede deshacer.')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/registros-marcas/clear/all`, {
          method: 'DELETE'
        });
        setSuccessMessage('Todos los registros eliminados');
        cargarRegistrosMarcas();
      } catch (error) {
        setErrorMessage('Error al limpiar registros');
      }
    }
  };

  const eliminarSesion = async (sessionId) => {
    if (window.confirm('¿Estás seguro de eliminar esta sesión?')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/sessions/${sessionId}`, {
          method: 'DELETE'
        });
        setSuccessMessage('Sesión eliminada exitosamente');
        cargarSesiones();
      } catch (error) {
        setErrorMessage('Error al eliminar sesión');
      }
    }
  };

  const limpiarTodasLasSesiones = async () => {
    if (window.confirm('⚠️ ¿ELIMINAR TODAS LAS SESIONES? Esta acción no se puede deshacer.')) {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/sessions/clear/all`, {
          method: 'DELETE'
        });
        setSuccessMessage('Todas las sesiones eliminadas');
        cargarSesiones();
      } catch (error) {
        setErrorMessage('Error al limpiar sesiones');
      }
    }
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData && userData.url) {
      setAvatarUrl(userData.url);
      setName(userData.nombre);
      setCell(userData.cell);
      // setEmail(userData.correo);
      setId(userData.id);
    }
  }, []);



  const generateToken = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 10; i += 1) { // Corregido aquí
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  const handleCreateUser = async () => {
    // Genera un token aquí o asegúrate de que `token` es el valor correcto que deseas enviar
    const generatedToken = generateToken();

    if (!isEmailValid) {
      setErrorMessage('Por favor, ingresa un correo electrónico válido.');
      return;
    }

    if (!phoneNumber || phoneNumber.length < 10) {
      setErrorMessage('Por favor, ingresa un número de teléfono válido (mínimo 10 dígitos).');
      return;
    }

    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      // Crear el usuario con numRegistros (este endpoint ya maneja la creación en crearuser)
      await api.post(`${process.env.REACT_APP_BACKEND_URL}/numRegistros`, {
        correo: email,
        numR: number,
        token: generatedToken
      });

      // Enviar SMS con el token
      const whatsappUrl = `https://wa.me/13132543163`;
      const smsMessage = `Bienvenido a Business Advocacy! Tu token de registro es: ${generatedToken}. Usa este token junto con tu correo ${email}. Para soporte contáctanos: ${whatsappUrl}`;
      
      await api.post(`${process.env.REACT_APP_BACKEND_URL}/send-sms`, {
        to: phoneNumber,
        message: smsMessage
      });

      // Ahora prepara el cuerpo del correo electrónico
      const emailHtmlContent = `
      <!DOCTYPE html>
      <html lang="es">
      <head>
          <meta charset="UTF-8">
          <title>Confirmación de pago</title>
          <style>
              body {
                  font-family: Arial, sans-serif;
                  margin: 0;
                  padding: 0;
              }
              .email-container {
                  max-width: 600px;
                  margin: auto;
                  background-color: #ffffff;
                  padding: 20px;
              }
              .header-logo {
                  text-align: center;
                  margin-bottom: 20px;
              }
              .content-block {
                  text-align: center;
              }
              .reservation-info {
                  background-color: #f9f9f9;
                  padding: 15px;
                  border-radius: 8px;
              }
              .reservation-info h2 {
                  color: #333333;
              }
              .steps-section {
                  background-color: #f2f2f2;
                  padding: 10px;
                  border-radius: 8px;
                  margin-top: 20px;
              }
              .step {
                  margin-bottom: 10px;
              }
              .button {
                  display: inline-block;
                  padding: 10px 15px;
                  margin: 5px;
                  background-color: #4CAF50;
                  color: white;
                  border-radius: 5px;
                  text-decoration: none;
              }
              .copyable-text {
                  border: 1px solid #cccccc;
                  padding: 5px;
                  border-radius: 4px;
                  position: relative;
                  display: inline-block;
                  cursor: pointer;
              }
              .copy-icon {
                  display: inline-block;
                  width: 24px;
                  height: 24px;
                  background-image: url('path-to-copy-icon.png');
                  background-size: cover;
                  vertical-align: middle;
                  margin-left: 8px;
              }
              .copy-tooltip {
                  visibility: hidden;
                  width: 120px;
                  background-color: black;
                  color: #fff;
                  text-align: center;
                  border-radius: 6px;
                  padding: 5px 0;
                  position: absolute;
                  z-index: 1;
                  bottom: 125%;
                  left: 50%;
                  margin-left: -60px;
              }
              .copy-tooltip::after {
                  content: "";
                  position: absolute;
                  top: 100%;
                  left: 50%;
                  margin-left: -5px;
                  border-width: 5px;
                  border-style: solid;
                  border-color: black transparent transparent transparent;
              }
              .copyable-text:hover .copy-tooltip {
                  visibility: visible;
              }
          </style>
      </head>
      <body>
          <div class="email-container">
              <div class="header-logo">
                  <img src="https://businessadvocacy.com.mx/wp-content/uploads/2022/09/cropped-logo_business-removebg-preview-1-1-239x300.png" alt="Logo" width="100"/>
              </div>
              <div class="content-block">
                  <h2>Se ha realizado la confirmación de su pago</h2>
                  <img src="https://cdn-icons-png.flaticon.com/512/9443/9443565.png" style="width: 10%;"/>
                  <div class="reservation-info">
                      <h3>Pasos a seguir: </h3>
                      <div class="steps-section">
                          <p class="step">Paso 1: <a href="http://businessadvocacy.shop/signup" target="_blank" class="button">Click aquí para registrarte</a></p>
                          <p class="step">Paso 2: Utilizar el mismo correo para la creación de tu cuenta: <span class="copyable-text">${email}</span></p>
                          <p class="step">Paso 3: En la sección de token, ingresar: <span class="copyable-text">${generatedToken}</span></p>
                          <p class="step">Paso 4: Completar los campos faltantes.</p>
                          <p class="step">Paso 5: <a href="http://businessadvocacy.shop/login" target="_blank" class="button">Ir a la página de inicio de sesión</a> y usar el correo y contraseña creados anteriormente.</p>
                      </div>
                      <a href="path-to-your-help-link" class="button">Obtener ayuda</a>
                  </div>
              </div>
          </div>
          <script>
              function copyToClipboard(text, element) {
                  navigator.clipboard.writeText(text).then(function () {
                      let tooltip = element.querySelector('.copy-tooltip');
                      tooltip.innerText = 'Copiado!';
                      setTimeout(function () {
                          tooltip.innerText = 'Copiar';
                      }, 1500);
                  }).catch(function (error) {
                      console.error('No se pudo copiar el texto: ', error);
                  });
              }
          </script>
      </body>
      </html>      
      `;

      // Envía el correo electrónico
      await api.post(`${process.env.REACT_APP_BACKEND_URL}/send-email`, {
        to: email,
        subject: "Bienvenido a Business advocacy",
        html: emailHtmlContent
      });

      setSuccessMessage(`Usuario creado con éxito! Se ha enviado el token por SMS al número ${phoneNumber} y por correo electrónico a ${email}`);
      
      // Limpiar campos
      setEmail('');
      setPhoneNumber('');
      setNumber('');
      
    } catch (error) {
      console.error("Error al crear usuario o enviar notificaciones:", error.response ? error.response.data : error.message);
      setErrorMessage('Error al crear usuario o enviar notificaciones. Por favor, intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };




  // Función para validar el correo electrónico
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Efecto para validar el correo electrónico cada vez que cambie
  useEffect(() => {
    setIsEmailValid(validateEmail(email));
  }, [email]);

  useEffect(() => {
    // Función para actualizar el token y reiniciar el progreso
    const updateTokenAndProgress = () => {
      setToken(generateToken());
      setProgress(100);
    };

    updateTokenAndProgress();
    const interval = setInterval(updateTokenAndProgress, 10000);

    // Función de limpieza para borrar el intervalo
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Función para actualizar la barra de progreso
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 0) {
          clearInterval(timer);
          return 0;
        }
        return Math.max(oldProgress - 1, 0);
      });
    }, 100); // Actualiza el progreso cada 100 ms

    return () => clearInterval(timer);
  }, []);


  return (
    <>
      <Helmet>
        <title>Admin create user</title>
      </Helmet>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="user management tabs">
            <Tab icon={<FaceIcon />} label="Crear Usuario" iconPosition="start" />
            <Tab icon={<PeopleIcon />} label="Usuarios Invitados" iconPosition="start" />
            <Tab icon={<HistoryIcon />} label="Historial de Registros" iconPosition="start" />
            <Tab icon={<AccountTreeIcon />} label="Sesiones Activas" iconPosition="start" />
          </Tabs>
        </Box>

        {/* Mensajes globales */}
        {successMessage && (
          <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccessMessage('')}>
            {successMessage}
          </Alert>
        )}

        {errorMessage && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setErrorMessage('')}>
            {errorMessage}
          </Alert>
        )}

        {/* TAB 1: Crear Usuario */}
        {tabValue === 0 && (
          <Card elevation={3} sx={{ borderRadius: 3, overflow: 'visible' }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ textAlign: 'center', mb: 4 }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: 'primary.main',
                    margin: '0 auto 16px',
                  }}
                >
                  <FaceIcon sx={{ fontSize: 48 }} />
                </Avatar>
                <Typography variant="h4" gutterBottom fontWeight="bold" color="primary">
                  Crear Nuevo Usuario
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Completa el formulario para generar credenciales de acceso
                </Typography>
              </Box>

              <Stack spacing={3}>
                <Box>
                  <TextField
                    fullWidth
                    label="Correo electrónico"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!isEmailValid && email.length > 0}
                    helperText={!isEmailValid && email.length > 0 ? "Correo electrónico no válido" : "El usuario recibirá las instrucciones en este correo"}
                    InputProps={{
                      startAdornment: <EmailIcon sx={{ mr: 1, color: 'action.active' }} />,
                    }}
                    disabled={loading}
                  />
                </Box>

                <Box>
                  <TextField
                    fullWidth
                    label="Número de teléfono"
                    variant="outlined"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="+529841234567"
                    helperText="Incluye código de país (ej: +52 para México)"
                    InputProps={{
                      startAdornment: <PhoneAndroidIcon sx={{ mr: 1, color: 'action.active' }} />,
                    }}
                    disabled={loading}
                  />
                </Box>

                <Box>
                  <TextField
                    fullWidth
                    label="Número de registros permitidos"
                    type="number"
                    variant="outlined"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    inputProps={{ min: 1, max: 10 }}
                    helperText="Define cuántos registros puede crear este usuario (1-10)"
                    disabled={loading}
                  />
                </Box>

                <Box sx={{ 
                  bgcolor: 'grey.100', 
                  p: 3, 
                  borderRadius: 2,
                  border: '2px dashed',
                  borderColor: 'primary.main'
                }}>
                  <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                    <VpnKeyIcon color="primary" />
                    <Typography variant="subtitle1" fontWeight="bold">
                      Token de acceso generado:
                    </Typography>
                  </Stack>
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={token}
                    InputProps={{
                      readOnly: true,
                      sx: { 
                        fontFamily: 'monospace', 
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        bgcolor: 'white'
                      }
                    }}
                  />
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      mt: 2,
                      height: 8,
                      borderRadius: 1,
                      bgcolor: 'grey.300',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: 'primary.main',
                        borderRadius: 1,
                      },
                    }}
                  />
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    El token se regenera automáticamente cada 10 segundos
                  </Typography>
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={loading ? null : <SendIcon />}
                  onClick={handleCreateUser}
                  disabled={loading || !isEmailValid || !phoneNumber || !number}
                  sx={{
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    boxShadow: 3,
                    '&:hover': {
                      boxShadow: 6,
                    }
                  }}
                >
                  {loading ? 'Creando usuario...' : 'Crear Usuario y Enviar Credenciales'}
                </Button>

                <Typography variant="caption" color="text.secondary" align="center" sx={{ pt: 2 }}>
                  Se enviará el token por SMS y las instrucciones completas por correo electrónico
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        )}

        {/* TAB 2: Usuarios Invitados */}
        {tabValue === 1 && (
          <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <PeopleIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                  <Box>
                    <Typography variant="h4" fontWeight="bold" color="primary">
                      Usuarios Invitados
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total: {usuariosInvitados.length} usuarios
                    </Typography>
                  </Box>
                </Box>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={cargarUsuariosInvitados}
                    disabled={loadingData}
                  >
                    Recargar
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={limpiarTodosLosUsuarios}
                  >
                    Limpiar Todo
                  </Button>
                </Stack>
              </Box>

              {loadingData ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : usuariosInvitados.length === 0 ? (
                <Alert severity="info">No hay usuarios invitados registrados</Alert>
              ) : (
                <TableContainer component={Paper} variant="outlined">
                  <Table>
                    <TableHead>
                      <TableRow sx={{ bgcolor: 'grey.100' }}>
                        <TableCell><strong>ID</strong></TableCell>
                        <TableCell><strong>Correo</strong></TableCell>
                        <TableCell><strong>Token</strong></TableCell>
                        <TableCell align="center"><strong>Acciones</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {usuariosInvitados.map((usuario) => (
                        <TableRow key={usuario.id} hover>
                          <TableCell>
                            <Chip label={usuario.id} size="small" color="primary" />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <EmailIcon fontSize="small" color="action" />
                              {usuario.correo}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ 
                              fontFamily: 'monospace', 
                              bgcolor: 'grey.100', 
                              p: 1, 
                              borderRadius: 1,
                              display: 'inline-block'
                            }}>
                              {usuario.token}
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              color="error"
                              onClick={() => eliminarUsuario(usuario.id)}
                              title="Eliminar usuario"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        )}

        {/* TAB 3: Historial de Registros */}
        {tabValue === 2 && (
          <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <HistoryIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                  <Box>
                    <Typography variant="h4" fontWeight="bold" color="primary">
                      Historial de Registros de Marcas
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total: {registrosMarcas.length} registros
                    </Typography>
                  </Box>
                </Box>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={cargarRegistrosMarcas}
                    disabled={loadingData}
                  >
                    Recargar
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={limpiarTodosLosRegistros}
                  >
                    Limpiar Todo
                  </Button>
                </Stack>
              </Box>

              {loadingData ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : registrosMarcas.length === 0 ? (
                <Alert severity="info">No hay registros de marcas</Alert>
              ) : (
                <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 600 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>ID</strong></TableCell>
                        <TableCell><strong>Teléfono</strong></TableCell>
                        <TableCell><strong>Marca</strong></TableCell>
                        <TableCell><strong>Nombre</strong></TableCell>
                        <TableCell><strong>Correo</strong></TableCell>
                        <TableCell><strong>Descripción</strong></TableCell>
                        <TableCell align="center"><strong>Proceso</strong></TableCell>
                        <TableCell align="center"><strong>Acciones</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {registrosMarcas.map((registro) => (
                        <TableRow key={registro.id} hover>
                          <TableCell>
                            <Chip label={registro.id} size="small" color="primary" />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <PhoneAndroidIcon fontSize="small" color="action" />
                              {registro.telefono}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" fontWeight="bold">
                              {registro.palabra || 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            {registro.name} {registro.apellido1}
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                              {registro.correo || 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography 
                              variant="body2" 
                              sx={{ 
                                maxWidth: 200, 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                              title={registro.descripcion}
                            >
                              {registro.descripcion || 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            {registro.proceso ? (
                              <Chip label="Completado" color="success" size="small" />
                            ) : (
                              <Chip label="Pendiente" color="warning" size="small" />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              <IconButton
                                color="primary"
                                onClick={() => enviarSMS(registro.telefono)}
                                title="Enviar SMS"
                                size="small"
                              >
                                <SmsIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="info"
                                onClick={() => resetearUsuario(registro.telefono)}
                                title="Resetear proceso"
                                size="small"
                              >
                                <RefreshIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="error"
                                onClick={() => eliminarRegistro(registro.id)}
                                title="Eliminar registro"
                                size="small"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        )}

        {/* TAB 4: Sesiones Activas */}
        {tabValue === 3 && (
          <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <AccountTreeIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                  <Box>
                    <Typography variant="h4" fontWeight="bold" color="primary">
                      Sesiones Activas de WhatsApp
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total: {sesiones.length} sesiones
                    </Typography>
                  </Box>
                </Box>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={cargarSesiones}
                    disabled={loadingData}
                  >
                    Recargar
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={limpiarTodasLasSesiones}
                  >
                    Limpiar Todo
                  </Button>
                </Stack>
              </Box>

              {loadingData ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : sesiones.length === 0 ? (
                <Alert severity="info">No hay sesiones activas</Alert>
              ) : (
                <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 600 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Session ID (Teléfono)</strong></TableCell>
                        <TableCell><strong>Email</strong></TableCell>
                        <TableCell><strong>Token</strong></TableCell>
                        <TableCell><strong>Estado</strong></TableCell>
                        <TableCell align="center"><strong>Acciones</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sesiones.map((sesion) => (
                        <TableRow key={sesion.session_id} hover>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <PhoneAndroidIcon fontSize="small" color="action" />
                              <Typography variant="body2" fontFamily="monospace">
                                {sesion.session_id}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <EmailIcon fontSize="small" color="action" />
                              {sesion.email || (
                                <Chip label="Sin email" size="small" color="default" />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            {sesion.token ? (
                              <Box sx={{ 
                                fontFamily: 'monospace', 
                                bgcolor: 'grey.100', 
                                p: 1, 
                                borderRadius: 1,
                                display: 'inline-block',
                                fontSize: '0.85rem'
                              }}>
                                {sesion.token}
                              </Box>
                            ) : (
                              <Chip label="Sin token" size="small" color="default" />
                            )}
                          </TableCell>
                          <TableCell>
                            {sesion.status ? (
                              <Chip 
                                label={sesion.status} 
                                size="small" 
                                color={
                                  sesion.status === 'finalizado' ? 'success' :
                                  sesion.status === 'verificacionData' ? 'warning' :
                                  'info'
                                }
                                sx={{ fontFamily: 'monospace' }}
                              />
                            ) : (
                              <Chip label="Sin iniciar" size="small" color="default" />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              <IconButton
                                color="primary"
                                onClick={() => enviarSMS(sesion.session_id)}
                                title="Enviar SMS"
                                size="small"
                              >
                                <SmsIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="error"
                                onClick={() => eliminarSesion(sesion.session_id)}
                                title="Eliminar sesión"
                                size="small"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        )}
      </Container>
    </>
  );
};

export default UserProfile;
